import { client } from './client';
import { endpoints } from './endpoints';

export async function requestMenuUpdate(menuUUID: string): Promise<void> {
  const response = await client.put(endpoints.REQUEST_MENU_UPDATE(menuUUID));

  return response.data;
}
